import Vue from 'vue';
import {Component, Watch} from 'vue-property-decorator';
import {namespace} from 'vuex-class' ;
import Axios from 'axios';
import {
  DOCUMENT_MODULE_NAMESPACE,
  DOCUMENT_SET_DOCUMENT_PARAMETER,
  DOCUMENT_GET_DOCUMENT_TYPES,
  DOCUMENT_GET_DOCUMENTS_ATTACHMENTS,
  DOCUMENT_LOADERS,
  DOCUMENT_SET_LOADER_STATE, DOCUMENT_GET_ATTACHMENT_TYPES, DOCUMENT_SET_DOCUMENTS_PAGINATION, DOCUMENT_DOWNLOAD_DOCUMENTS
} from '../../../../store/document';
import {IDocumentParamter, IDocumentTypeListingViewmodel} from '../../../../models/documents';
import {IBlockParameter} from '../../../../models/block';
import {BLOCK_GET_BLOCKS_AUTOCOMPLETE, BLOCK_MODULE_NAMESPACE} from '../../../../store/block';
import {APARTMENT_MODULE_NAMESPACE, APARTMENT_GET_APPARTMENTS_AUTOCOMPLETE} from '../../../../store/apartment';
import {SEARCH_MODULE_NAMESPACE, SEARCH_AUTOCOMPLETE} from '../../../../store/search';
import {SearchEntities, UserTemplate} from '../../../../common/enums';
import { AttributeService } from '../../../../services/attribute.service';
import { EQUIPMENT_GET_EQUIPMENTS, MAINTENANCE_MODULE_NAMESPACE } from '../../../../store/maintenance';
import { USER_MODULE_NAMESPACE } from '../../../../store/user/user-types.store';
import { SERIVCEBOOK_MODULE_NAMESPACE, SERVICEBOOK_GET_SERVICEBOOK } from '../../../../store/service-book';
import { IServiceBookDetails } from '../../../../store/service-book/service-book-state.store';
import { IUserDetails } from '../../../../models/user'
const DocumentStore = namespace(DOCUMENT_MODULE_NAMESPACE)
const BlockStore = namespace(BLOCK_MODULE_NAMESPACE)
const ApartmentStore = namespace(APARTMENT_MODULE_NAMESPACE)
const SearchStore = namespace(SEARCH_MODULE_NAMESPACE)
const MaintenanceStore = namespace(MAINTENANCE_MODULE_NAMESPACE)
const UserStore = namespace(USER_MODULE_NAMESPACE)
const ServiceBookStore = namespace(SERIVCEBOOK_MODULE_NAMESPACE)

@Component({
  components: {
    'document-filters-loader': async () => import('../../loaders/document-filters-loader/DocumentFiltersLoader.vue')
  }
})
class DocumentItemConditions extends Vue {
  dtTemporaryCreators: any[] | null
  dtIsEmptyTypesFilter: boolean
  dtTemporaryCategories: any[]
  dtTemporarySubcategories: any[]



  /* ===== attribut filter data ======= */
  validFormAttributFilter:boolean
  showAttributFilter:boolean
  FkAttribut:any
  FkAttributOpertor:any
  allFilterAttributs:any[]
  allFilterAttributsOperators:any[]
  dtFilterAttributs:any[]
  dtFilterAttributsOperators:any[]
  attributFilterVal1:string
  attributFilterVal2:string
  attributFilterDate1Formated:string
  attributFilterDate2Formated:string
  attributeService:AttributeService
  AttributFilterDateValue1:boolean
  AttributFilterDateValue2:boolean
  /* ===== attribut filter data ======= */



  constructor() {
    super()
    this.dtTemporaryCreators = []
    this.dtTemporaryCategories = []
    this.dtTemporarySubcategories = []
    this.dtIsEmptyTypesFilter = false

    /* ===== attribut filter data ======= */
    this.attributeService = new AttributeService()
    this.AttributFilterDateValue1 = false
    this.AttributFilterDateValue2 = false
    this.attributFilterDate1Formated = '' //this.formatDate(new Date().toISOString().substring(0,10))
    this.attributFilterDate2Formated = '' //this.formatDate(new Date().toISOString().substring(0,10))
    this.validFormAttributFilter = false
    this.showAttributFilter = false
    this.FkAttribut = null
    this.FkAttributOpertor = null
    this.dtFilterAttributs = []
    this.dtFilterAttributsOperators = []
    this.attributFilterVal1 = null
    this.attributFilterVal2 = null
    this.allFilterAttributs = []
    this.allFilterAttributsOperators = [
      {
        id:1,
        name:'égal à',
        symbol:'=',
        types:['all'],
        nbOfValue:1
      },
      {
        id:2,
        name:'supérieur à',
        symbol:'>',
        types:['number', 'date'],
        nbOfValue:1
      },
      {
        id:3,
        name:'supérieur ou égal à',
        symbol:'>=',
        types:['number', 'date'],
        nbOfValue:1
      },
      {
        id:4,
        name:'inferieur à',
        symbol:'<',
        types:['number', 'date'],
        nbOfValue:1
      },
      {
        id:5,
        name:'inferieur ou égal à',
        symbol:'<=',
        types:['number', 'date'],
        nbOfValue:1
      },
      {
        id:6,
        name:'entre',
        symbol:'<>',
        types:['number', 'date'],
        nbOfValue:2
      },
      {
        id:7,
        name:'contient',
        symbol:'%',
        types:['string'],
        nbOfValue:1
      },
      {
        id:8,
        name:'ne contient pas',
        symbol:'!%',
        types:['string'],
        nbOfValue:1
      },
      {
        id:9,
        name:'différent de',
        symbol:'!=',
        types:['all'],
        nbOfValue:1
      },
    ]
    /* ===== attribut filter data ======= */
  }

  @ServiceBookStore.Getter currentServiceBook:IServiceBookDetails
  @ServiceBookStore.Action(SERVICEBOOK_GET_SERVICEBOOK)
  storeGetServiceBook: (id:string) => Promise<any>

  @DocumentStore.Getter documentParameter: IDocumentParamter;
  @DocumentStore.Getter documentTypes: any[]
  @UserStore.Getter modules: any[]

  @BlockStore.Action(BLOCK_GET_BLOCKS_AUTOCOMPLETE)
  storeGetBlocksAutocomplete: (param: IBlockParameter) => Promise<any>

  @ApartmentStore.Action(APARTMENT_GET_APPARTMENTS_AUTOCOMPLETE)
  storeGetApartmentsAutocomplete: (param: { blockId: number | number[], key: string }) => Promise<any>

  @MaintenanceStore.Action(EQUIPMENT_GET_EQUIPMENTS)
  storeGetEquipments: (param: { blockId: number | number[], key: string }) => Promise<any>

  @SearchStore.Action(SEARCH_AUTOCOMPLETE)
  storeGetEntitySearch: (
    payload: { entity?: SearchEntities | SearchEntities[], query?: string, limit?: number, apartment?: number[], block?: number[] }
  ) => Promise<any>;

  @DocumentStore.Action(DOCUMENT_GET_DOCUMENTS_ATTACHMENTS)
  storeGetDocumentAttachments: () => Promise<any>

  @DocumentStore.Action(DOCUMENT_DOWNLOAD_DOCUMENTS)
  storeDownloadDocuments: (param) => Promise<any>

  @DocumentStore.Action(DOCUMENT_GET_DOCUMENT_TYPES)
  storeGetDocumentsTypes: () => Promise<any>

  @DocumentStore.Action(DOCUMENT_GET_ATTACHMENT_TYPES)
  storeGetAttachmentTypes: (id?: number) => Promise<any>

  @DocumentStore.Mutation(DOCUMENT_SET_DOCUMENT_PARAMETER)
  storeSetDocumentParameter: (payload: IDocumentParamter) => void

  @DocumentStore.Mutation(DOCUMENT_SET_LOADER_STATE)
  storeSetLoaderState: (payload?: { key: string, value: boolean }) => void

  @DocumentStore.Mutation(DOCUMENT_SET_DOCUMENTS_PAGINATION)
  storeSetDocumentPagination: (payload?: any) => void
  @UserStore.Getter userInfo: IUserDetails
  get lblSetting() {
    return {
      ...require('@/locales/document').default,
      ...require('@/locales/maintenance').default,
      ...require('@/locales/generic-labels').default
    }
  }

  get coCategories() {
    return this.dtTemporaryCategories.map((type: any) => ({
      value: type.id,
      text: type.name
    }))
    /* return this.documentTypes.map((documentType: any) => ({
      value: documentType.fk_attachment_type,
      text: documentType.name
    })) */
  }

  get coSubcategories() {
    return this.dtTemporarySubcategories.map((type: any) => ({
      value: type.id,
      text: type.name
    }))
  }

  get fkCategory() {
    console.log('docdoc parameter', this.documentParameter.fk_attachment_type)
    return this.documentParameter.fk_attachment_type.length ? this.documentParameter.fk_attachment_type[0] : null
  }

  set fkCategory(types: number) {
    this.storeSetDocumentParameter(
      {fk_attachment_type: types && this.fkCategory !== types ? [types] : []/* this.documentTypes.map(docType => docType.fk_attachment_type) */}
    )
    this.fKSubcategory = null
    this.storeSetDocumentPagination({page: 1})
    this.storeGetDocumentAttachments()
      .finally(() => {
        if (!types) this.storeSetDocumentParameter({fk_attachment_type: []})
      })
  }

  get fKSubcategory() {
    return this.documentParameter.fk_attachment_type_level_2 ? this.documentParameter.fk_attachment_type_level_2[0] : null
  }

  set fKSubcategory(type: number) {
    this.storeSetDocumentParameter({fk_attachment_type_level_2: type && this.fKSubcategory !== type ? [type] : []})
    this.storeSetDocumentPagination({page: 1})
    this.storeGetDocumentAttachments()
  }

  get fKDocumentBlock() {
    return this.documentParameter.block
  }

  set fKDocumentBlock(blocks: number[]) {
    this.storeSetDocumentParameter({block: blocks})
    this.storeSetDocumentPagination({page: 1})
    this.storeGetDocumentAttachments()
  }

  get fKDocumentEquipment() {
    return this.documentParameter.equipment
  }

  set fKDocumentEquipment(equipments: number[]) {
    this.storeSetDocumentParameter({equipment: equipments})
    this.storeSetDocumentPagination({page: 1})
    this.storeGetDocumentAttachments()
  }


  get fKDocumentApartment() {
    return this.documentParameter.apartment
  }

  set fKDocumentApartment(apartment: number[]) {
    const params: any = {apartment}
    /* if (!this.documentParameter.fk_attachment_type.length) {
      this.dtIsEmptyTypesFilter = true
      params.fk_attachment_type = this.documentTypes.map(docType => docType.fk_attachment_type)
    } */

    this.storeSetDocumentParameter(params)
    this.storeSetDocumentPagination({page: 1})
    this.storeGetDocumentAttachments()
      .finally(() => {
        /* if (this.dtIsEmptyTypesFilter) {
          this.dtIsEmptyTypesFilter = false
          this.storeSetDocumentParameter({fk_attachment_type: []})
        } */
      })
  }

  get fkDocumentCreator() {
    return this.documentParameter.creator
  }

  set fkDocumentCreator(creator: number[]) {
    this.storeSetDocumentParameter({creator})
    this.storeSetDocumentPagination({page: 1})
    this.storeGetDocumentAttachments()
  }

  get coBlocks() {
    return []
  }

  get coApartments() {
    return []
  }

  get coEquipments() {
    return []
  }

  get coCreators() {
    return this.dtTemporaryCreators.map(x => ({value: x.id, text: x.fullname}))
  }

  get layoutPadding() {
    return this.$vuetify.breakpoint.lgAndDown ? 'px-0' : 'px-3'
  }

  get displayLvl2 () {
    if (this.$route.name === 'block_documents') return this.$route.meta['media_type_level2_allowed'] && this.fkCategory
    return this.$route.meta['media_type_level2_allowed']
  }

  get isServiceBook():boolean {
    return this.$route.path.includes('service-book')
  }
  get isServiceBookUser():boolean {
    return this.userInfo.template !== UserTemplate.default
  }
  created()
  {
    console.log('before mount .....................')
    if(this.$route.params.equipmentId)
    {
      this.coEquipments.push({value:parseInt(this.$route.params.equipmentId), text:this.$route.params.equipmentName})
      this.fKDocumentEquipment = [parseInt(this.$route.params.equipmentId)]
    }
  }

  beforeDestroy()
  {
    this.resetFilters()
  }

  mounted () {
    this.storeGetEntitySearch({entity: [SearchEntities.Manager, SearchEntities.Salesperson], query: ''})
      .then(res => {
        this.dtTemporaryCreators = res
      })

    if (this.$route.name === 'block_documents' || this.$route.name === 'service_book_details') {
      this.handleGetCategory()
    } else {
      this.handleGetSubcategory(parseInt(this.$route.params.id, 10))
      // this.fkCategory = parseInt(this.$route.params.id, 10)
    }

    /* ===== attribut filter data ======= */
    // get all attributes
    this.attributeService.getAttributes({type:'document'}).then(response=>{
      //console.log(response)
      this.allFilterAttributs = response

      if(this.attributeFilters.length) {
        this.showAttributFilter = true
        console.log(this.attributeFilters)
        const selected = []
        this.attributeFilters.forEach(el=>selected.push(el.attribut.id))
        const filtrerd = []
        this.allFilterAttributs.map(dtAtt=>{
          if(selected.indexOf(dtAtt.id)===-1){
            filtrerd.push(dtAtt)
          }
        })
        this.dtFilterAttributs = filtrerd
      } else {
        this.dtFilterAttributs = this.allFilterAttributs
      }
    })
    /* ===== attribut filter data ======= */
  }

  destroyed() {
    this.fKSubcategory = null
  }

  formatDate (date:string):string {
    if (!date) return null

    const [year, month, day] = date.split('-')
    return `${day}/${month}/${year}`
  }

  @Watch('attributFilterVal1')
  attributFilterVal1Changed(date){
    this.attributFilterDate1Formated = this.formatDate(date)
  }

  @Watch('attributFilterVal2')
  attributFilterVal2Changed(date){
    this.attributFilterDate2Formated = this.formatDate(date)
  }

  resetFilters()
  {
    this.storeSetDocumentPagination({page: 1})
    this.storeSetDocumentParameter({
      attributeFilters: JSON.stringify([]),
      equipment:[],
      $limit:10,
      $skip:0,
      apartment:[],
      //fk_attachment_type:[],
      //fk_attachment_type_level_2:[],
      block:[],
      creator:[]
    })
    this.storeGetDocumentAttachments()

    /* if(this.$route.name === 'block_documents')
    {
      this.documentParameter.fk_attachment_type = []
    }
    if(this.$route.name === 'document_attachment')
    {
      this.documentParameter.block = []
      this.documentParameter.creator = []
    } */
  }

  /* ===== attribut filter data ======= */
  @Watch('FkAttribut')
  FkAttributChanged(val)
  {
    if(val)
    {
      //console.log(val)
      const attributType = val.attribute_type.type
      this.dtFilterAttributsOperators = this.allFilterAttributsOperators.filter(item=>item.types.includes('all') || item.types.includes(attributType))
    } else {
      this.FkAttributOpertor = null
      this.attributFilterVal1 = null
      this.attributFilterVal2 = null
    }
  }

  @Watch('FkAttributOpertor')
  FkAttributOpertorChanged(val)
  {
    if(val){}else{
      this.attributFilterVal1 = null
      this.attributFilterVal2 = null
      this.AttributFilterDateValue1 = false
      this.AttributFilterDateValue2 = false
    }
  }
  truncateString(str, num) {
    // If the length of str is less than or equal to num
    // just return str--don't truncate it.
    if (str.length <= num) {
      return str
    }
    // Return str truncated with '...' concatenated to the end of str.
    return str.slice(0, num) + '...'
  }
  AddAttributFilter()
  {
    this.attributeFilters.push({
      attribut:this.FkAttribut,
      operator:this.FkAttributOpertor,
      value1:this.attributFilterVal1,
      value2:this.attributFilterVal2
    })
    // === delete selected attribut
    const filtred = this.dtFilterAttributs.filter(item=>item.id!==this.FkAttribut.id)
    this.dtFilterAttributs = filtred
    this.FkAttribut = null
    this.storeSetDocumentParameter({attributeFilters: JSON.stringify(this.attributeFilters)})
  }
  ApplyAttributeFilters()
  {
    this.documentParameter.$limit = 10
    this.documentParameter.$skip = 0
    this.storeSetDocumentPagination({page: 1})
    this.storeGetDocumentAttachments()
  }
  removeFilter(index)
  {
    //console.log(this.attributeFilters[index])
    // == add attribut to list
    this.dtFilterAttributs.push(this.attributeFilters[index].attribut)
    this.attributeFilters.splice(index, 1)
    this.storeSetDocumentParameter({attributeFilters: JSON.stringify(this.attributeFilters)})
  }
  get attributeFilters (): any[] {
    return JSON.parse(this.documentParameter.attributeFilters)
  }
  /* ===== attribut filter data ======= */


  /* handleCategoryRemoteFetch(key: string, cb: Function, loading: Function) {
    this.storeGetAttachmentTypes(null)
      .then(res => {
        cb((res || []).map(x => ({value: x.id, text: x.name})))
        loading && loading(false)
      })
      .catch(error => console.log(error))
  } */

  handleGetCategory () {
    this.storeGetAttachmentTypes(null)
      .then(res => {
        this.dtTemporaryCategories = res
      })
      .catch(error => console.log(error))
  }

  handleSubcategoryRemoteFetch(key: string, cb: Function, loading: Function) {
    let level1Id = parseInt(this.$route.params.id, 10)
    if (this.$route.name === 'block_documents' || this.$route.name === 'service_book_details') {
      level1Id = this.fkCategory
    }
    this.storeGetAttachmentTypes(level1Id)
      .then(res => {
        cb((res.level_2 || []).map(x => ({value: x.id, text: x.name})))
        loading && loading(false)
      })
      .catch(error => console.log(error))
  }

  onChangeCategory () {
    console.log('azeazeazea', this.fkCategory)
    if (!this.fkCategory) {
      this.dtTemporarySubcategories = []
      return
    }
    this.handleGetSubcategory(this.fkCategory)
  }

  handleGetSubcategory (category) {
    this.storeGetAttachmentTypes(category)
      .then(res => {
        this.dtTemporarySubcategories = res.level_2
      })
      .catch(error => console.log(error))
  }

  handleBlockRemoteFetch (key: string, cb: Function, loading: Function) {
    this.storeGetBlocksAutocomplete({key})
      .then(res => {
        cb((res || []).map(x => ({value: x.id, text: x.name})))
        loading && loading(false)
      })
      .catch(error => console.log(error))
  }



  handleEquipmentRemoteFetch(key: string, cb: Function, loading: Function) {
    const param: any = {q: key}

    if (this.fKDocumentBlock) {
      param.block = this.fKDocumentBlock
    }

    if(this.isServiceBook)
    {
      if(!this.currentServiceBook.apartment)
      {
        this.storeGetServiceBook(this.$route.params.id).then(()=>{
          param.apartment = this.currentServiceBook.apartment.id
          param.block = this.currentServiceBook.apartment.fk_apartment_block
          this.storeGetEquipments(param)
          .then(res => {
            cb((res || []).map(x => ({
              value: x.id, text: x.reference ? `(${x.reference}) - ${x.name}` : x.name
            })))
            loading && loading(false)
          })
          .catch(error => console.log(error))
        })
      } else {
        param.apartment = this.currentServiceBook.apartment.id
        param.block = this.currentServiceBook.apartment.fk_apartment_block
        this.storeGetEquipments(param)
        .then(res => {
          cb((res || []).map(x => ({
            value: x.id, text: x.reference ? `(${x.reference}) - ${x.name}` : x.name
          })))
          loading && loading(false)
        })
        .catch(error => console.log(error))
      }
    }
    else
    {
      this.storeGetEquipments(param)
      .then(res => {
        cb((res || []).map(x => ({
          value: x.id, text: x.reference ? `(${x.reference}) - ${x.name}` : x.name
        })))
        loading && loading(false)
      })
      .catch(error => console.log(error))
    }
  }


  handleApartmentRemoteFetch(key: string, cb: Function, loading: Function) {
    const param: any = {key: key}

    if (this.fKDocumentBlock) {
      param.blockId = this.fKDocumentBlock
    }

    this.storeGetApartmentsAutocomplete(param)
      .then(res => {
        cb((res || []).map(x => ({
          value: x.id, text: x.apartment_number
        })))
        loading && loading(false)
      })
      .catch(error => console.log(error))
  }

  handleCreatorsRemoteFetch(key: string, cb: Function, loading: Function) {
    return this.storeGetEntitySearch({
      entity: [SearchEntities.Manager, SearchEntities.Salesperson], query: key, limit: 50
    })
      .then(res => {
        cb((res || []).map(x => ({value: x.id, text: x.fullname})))
        loading && loading(false)
      })
      .catch(error => console.log(error))
  }

  setFilterLoaderState(value: boolean) {
    this.storeSetLoaderState({key: DOCUMENT_LOADERS.FILTERS_LOADER, value})
  }

  downloadDocument(){
    const params = this.documentParameter;
    console.log('params :>> ', params);
    this.storeDownloadDocuments(params).then(res =>{
      console.log('result :>> ', res);
      let url = res.download_zip_url;
      if(url){
        window.open(url, '_blank', 'noreferrer');
      }
    }).catch(error => console.log(error));
  }
}


export default DocumentItemConditions



// WEBPACK FOOTER //
// ./src/containers/documents/components/document-item-conditions/index.ts